import { BrandName, StyleSchema } from "@models/color-schema.model";
import klierDisturber from "@assets/brands/klier/disturber.png";
import essanelleDisturber from "@assets/brands/essanelle/disturber.png";
import cosmoDisturber from "@assets/brands/cosmo/disturber.png";
import hairexpressDisturber from "@assets/brands/hairexpress/disturber.png";
import styleboxxDisturber from "@assets/brands/styleboxx/disturber.png";
import supercutDisturber from "@assets/brands/supercut/disturber.png";
import klierLogoWhite from "@assets/brands/klier/logo-weiss.svg";
import klierLogoBlue from "@assets/brands/klier/logo.svg";
import klierFavicon from "@assets/brands/klier/favicon.ico";
import essanelleLogo from "@assets/brands/essanelle/logo.png";
import essanelleFavicon from "@assets/brands/essanelle/disturber.png";
import klierHero from "@assets/brands/klier/hero.jpg";
import essanelleHero from "@assets/brands/essanelle/hero.jpg";
import cosmoHero from "@assets/brands/cosmo/hero.jpg";
import hairexpressHero from "@assets/brands/hairexpress/hero.jpg";
import styleboxxHero from "@assets/brands/styleboxx/hero.jpg";
import supercutHero from "@assets/brands/supercut/hero.jpg";
import styleboxxLogo from "@assets/brands/styleboxx/logo.png";
import styleboxxFavicon from "@assets/brands/styleboxx/favicon.png";
import cosmoLogo from "@assets/brands/cosmo/logo.png";
import hairexpressLogo from "@assets/brands/hairexpress/logo.png";
import supercutLogo from "@assets/brands/supercut/logo.png";
import klierNewsletter from "@assets/brands/klier/newsletter.jpg";
import essanelleNewsletter from "@assets/brands/essanelle/newsletter.jpg";
import cosmoNewsletter from "@assets/brands/cosmo/newsletter.jpg";
import hairexpressNewsletter from "@assets/brands/hairexpress/newsletter.jpg";
import styleboxxNewsletter from "@assets/brands/styleboxx/newsletter.jpg";
import supercutNewsletter from "@assets/brands/supercut/newsletter.jpg";

export const BRAND_CONFIGS: Record<BrandName, StyleSchema> = {
  klier: {
    name: "klier",
    brandId: 1,
    title: "KLIER BonusCard",
    brandString: "KLIER",
    colors: {
      primary: {
        hex: "#003366",
        rgb: "0, 26, 114",
        cmyk: "100, 95, 0, 15",
        pantone: "2747",
        ral: "5013",
      },
      secondary: {
        hex: "#fff7f0",
        rgb: "255, 247, 240",
        cmyk: "0, 4, 7, 0",
        pantone: "9224C",
        ral: "1013",
      },
      accent: {
        hex: "#387DAB",
        rgb: "56, 125, 171",
        cmyk: "40, 90, 0, 0",
        pantone: "2415C",
        ral: "4006",
      },
    },
    logo: {
      main: {
        // @ts-ignore - SVG Import hat keine .src Eigenschaft in TypeScript, funktioniert aber zur Laufzeit
        path: klierLogoWhite.src,
        size: {
          width: "180px",
          height: "auto",
        },
        position: {
          x: "center",
          y: "center",
          padding: "0px",
        },
      },
      favicon: klierFavicon.src,
      footer: {
        // @ts-ignore - SVG Import hat keine .src Eigenschaft in TypeScript, funktioniert aber zur Laufzeit
        path: klierLogoBlue.src,
        size: {
          width: "200px",
          height: "auto",
        },
        position: {
          x: "left",
          y: "center",
          padding: "0px",
        },
      },
      
    },
    disturber: {
      title: "Klier BonusCard",
      imagePath: klierDisturber.src,
      altText: "BonusCard bei Klier",
      ctaText: "Jetzt buchen",
      ctaLink: "/angebote/sommer",
    },
    typography: {
      fontFamily: '"Open Sans", sans-serif',
      headingsFontFamily: '"Montserrat", sans-serif',
      primaryFontWeight: 600,
    },
    hero: {
      background: klierHero.src,
      textColor: "var(--accent-klier)",
      heroFooterBackground: "var(--header-klier)",
      heroFooterTextColor: "",
    },
    backgrounds: {
      header: "var(--header-klier)",
      footer: "var(--footer-klier)",
      accent: "var(--accent-klier)",
    },
    contactForm: {
      background: "var(--header-klier)",
      link: "https://www.klier.de/kontakt",
    },
    newsletter: {
      background: "var(--header-klier)",
      path: klierNewsletter.src,
      link: "https://klierhairgroup.de/newsletter-formular",
    },
    faq: {
      background: "",
      path: "",
      link: "https://www.klier.de/faq",
    },
    terms: {
      loyaltyLink: "https://www.klier.de/agb/",
      termsLink: "https://www.klier.de/agb/",
      privacyLink: "https://www.klier.de/datenschutz/"
    },
  },

  essanelle: {
    name: "essanelle",
    brandId: 2,
    title: "Essanelle BonusCard",
    brandString: "essanelle",
    colors: {
      primary: {
        hex: "#ee7203",
        rgb: "238, 114, 3",
        cmyk: "0, 65, 100, 0",
        pantone: "021",
        ral: "2004",
      },
      secondary: {
        hex: "#a69dcd",
        rgb: "166, 157, 205",
        cmyk: "40, 40, 0, 0",
        pantone: "2645",
        ral: "4005",
      },
      accent: {
        hex: "#493f39",
        rgb: "73, 63, 57",
        cmyk: "0, 20, 20, 85",
        pantone: "411",
        ral: "7022",
      },
    },
    logo: {
      main: {
        // @ts-ignore - SVG Import hat keine .src Eigenschaft in TypeScript, funktioniert aber zur Laufzeit
        path: essanelleLogo.src,
        size: {
          width: "200px",
          height: "auto",
        },
        position: {
          x: "center",
          y: "center",
          padding: "0px",
        },
      },
      favicon: essanelleFavicon.src,
      footer: {
        // @ts-ignore - SVG Import hat keine .src Eigenschaft in TypeScript, funktioniert aber zur Laufzeit
        path: essanelleLogo.src,
        size: {
          width: "200px",
          height: "auto",
        },
        position: {
          x: "left",
          y: "center",
          padding: "0px",
        },
      },
    },
    disturber: {
      title: "Essanelle BonusCard",
      imagePath: essanelleDisturber.src,
      altText: "Beauty Special bei Essanelle",
      ctaText: "Mehr erfahren",
      ctaLink: "/angebote/beauty",
    },
    typography: {
      fontFamily: '"Playfair Display", serif',
      headingsFontFamily: '"Raleway", sans-serif',
      primaryFontWeight: 500,
    },
    hero: {
      background: essanelleHero.src,
      textColor: "var(--header-essanelle)",
      heroFooterBackground: "#7F7874",
      heroFooterTextColor: "",
    },
    backgrounds: {
      header: "var(--header-essanelle)",
      footer: "var(--footer-essanelle)",
      accent: "var(--header-essanelle)",
    },
    contactForm: {
      background: "var(--header-essanelle)",
      link: "https://essanelle-friseur.de/kontakt",
    },
    newsletter: {
      background: "var(--header-essanelle)",
      path: essanelleNewsletter.src,
      link: "https://klierhairgroup.de/newsletter-formular",
    },
    faq: {
      background: "",
      path: "",
      link: "https://essanelle-friseur.de/faq",
    },
    terms: {
      loyaltyLink: "https://essanelle-friseur.de/agb",
      termsLink: "https://essanelle-friseur.de/agb",
      privacyLink: "https://essanelle-friseur.de/datenschutz/"
    },
  },

  supercut: {
    name: "supercut",
    brandId: 3,
    title: "SuperCut BonusCard",
    brandString: "SuperCut",
    colors: {
      primary: {
        hex: "#ea5297",
        rgb: "234, 82, 151",
        cmyk: "0, 80, 0, 0",
        pantone: "205C",
        ral: "4003",
      },
      secondary: {
        hex: "#ffde14",
        rgb: "255, 224, 20",
        cmyk: "0, 10, 90, 0",
        pantone: "7405C",
        ral: "1016",
      },
      accent: {
        hex: "#00afcb",
        rgb: "0, 175, 203",
        cmyk: "80, 0, 20, 0",
        pantone: "298C",
        ral: "5015",
      },
      accent2: {
        hex: "#49b170",
        rgb: "73, 177, 112",
        cmyk: "70, 0, 70, 0",
        pantone: "2414C",
        ral: "6032",
      },
    },
    logo: {
      main: {
        path: supercutLogo.src,
        size: {
          width: "120px",
          height: "auto",
        },
        position: {
          x: "center",
          y: "center",
          padding: "0px",
        },
      },
      favicon: supercutLogo.src,
      footer: {
        path: supercutLogo.src,
        size: {
          width: "75px",
          height: "auto",
        },
        position: {
          x: "left",
          y: "center",
          padding: "0px",
        },
      },
    },
    disturber: {
      title: "SuperCut BonusCard",
      imagePath: supercutDisturber.src,
      altText: "Blitzangebot bei SuperCut",
      ctaText: "Jetzt sparen",
      ctaLink: "/angebote/blitz",
    },
    typography: {
      fontFamily: '"Roboto", sans-serif',
      headingsFontFamily: '"Anton", sans-serif',
      primaryFontWeight: 700,
    },
    hero: {
      background: supercutHero.src,
      textColor: "#EA5297",
      heroFooterBackground: "#000000",
      heroFooterTextColor: "",
    },
    backgrounds: {
      header: "var(--header-supercut)",
      footer: "var(--footer-supercut)",
      accent: "var(--accent-supercut)",
    },
    contactForm: {
      background: "var(--header-supercut)",
      link: "https://supercut-friseur.de/kontakt",
    },
    newsletter: {
      background: "var(--header-supercut)",
      path: supercutNewsletter.src,
      link: "https://klierhairgroup.de/newsletter-formular",
    },
    faq: {
      background: "",
      path: "",
      link: "https://supercut-friseur.de/faq",
    },
    terms: {
      loyaltyLink: "https://supercut-friseur.de/agb",
      termsLink: "https://supercut-friseur.de/agb",
      privacyLink: "https://supercut-friseur.de/datenschutz/"
    },
  },

  styleboxx: {
    name: "styleboxx",
    brandId: 4,
    title: "Styleboxx BonusCard",
    brandString: "Styleboxx",
    colors: {
      primary: {
        hex: "#9a1c21",
        rgb: "154, 28, 33",
        cmyk: "0, 82, 79, 40",
        pantone: "1815C",
        ral: "3004",
      },
      secondary: {
        hex: "#e3000f",
        rgb: "227, 0, 15",
        cmyk: "0, 100, 93, 11",
        pantone: "485C",
        ral: "3020",
      },
      accent: {
        hex: "#000000",
        rgb: "0, 0, 0",
        cmyk: "0, 0, 0, 100",
        pantone: "Black C",
        ral: "9005",
      },
    },
    logo: {
      main: {
        path: styleboxxLogo.src,
        size: {
          width: "200px",
          height: "auto",
        },
        position: {
          x: "center",
          y: "center",
          padding: "0px",
        },
      },
      favicon: styleboxxFavicon.src,
      footer: {
        path: styleboxxLogo.src,
        size: {
          width: "200px",
          height: "auto",
        },
        position: {
          x: "left",
          y: "center",
          padding: "0px",
        },
      },
    },
    disturber: {
      title: "Styleboxx BonusCard",
      imagePath: styleboxxDisturber.src,
      altText: "Neue Trend Collection bei Styleboxx",
      ctaText: "Entdecken",
      ctaLink: "/angebote/trends",
    },
    typography: {
      fontFamily: '"Poppins", sans-serif',
      headingsFontFamily: '"Bebas Neue", cursive',
      primaryFontWeight: 500,
    },
    hero: {
      background: styleboxxHero.src,
      textColor: "#000000",
      heroFooterBackground: "#575454",
      heroFooterTextColor: "",
    },
    backgrounds: {
      header: "var(--header-styleboxx)",
      footer: "var(--footer-styleboxx)",
      accent: "var(--accent-styleboxx)",
    },
    contactForm: {
      background: "#575454",
      link: "https://styleboxx-klier.de/kontakt",
    },
    newsletter: {
      background: "var(--header-styleboxx)",
      path: styleboxxNewsletter.src,
      link: "https://klierhairgroup.de/newsletter-formular",
    },
    faq: {
      background: "",
      path: "",
      link: "https://styleboxx-klier.de/faq",
    },
    terms: {
      loyaltyLink: "https://www.styleboxx-klier.de/agb",
      termsLink: "https://www.styleboxx-klier.de/agb",
      privacyLink: "https://www.styleboxx-klier.de/datenschutz/"
    },
  },

  hairexpress: {
    name: "hairexpress",
    brandId: 5,
    title: "HairExpress BonusCard",
    brandString: "HairExpress",
    colors: {
      primary: {
        hex: "#575454",
        rgb: "87, 84, 84",
        cmyk: "0, 5, 0, 80",
        pantone: "425C",
        ral: "7011",
      },
      secondary: {
        hex: "#e30613",
        rgb: "227, 6, 19",
        cmyk: "0, 100, 100, 0",
        pantone: "485C",
        ral: "3028",
      },
      accent: {
        hex: "var(--accent-hairexpress)",
        rgb: "255, 255, 255",
        cmyk: "0, 0, 0, 0",
        pantone: "WHITE",
        ral: "9016",
      },
    },
    logo: {
      main: {
        path: hairexpressLogo.src,
        size: {
          width: "220px",
          height: "auto",
        },
        position: {
          x: "center",
          y: "center",
          padding: "0px",
        },
      },
      favicon: klierFavicon.src,
      footer: {
        path: hairexpressLogo.src,
        size: {
          width: "200px",
          height: "auto",
        },
        position: {
          x: "left",
          y: "center",
          padding: "0px",
        },
      },
    },
    disturber: {
      title: "HairExpress BonusCard",
      imagePath: hairexpressDisturber.src,
      altText: "Schnellservice bei HairExpress",
      ctaText: "Ohne Termin kommen",
      ctaLink: "/angebote/ohne-termin",
    },
    typography: {
      fontFamily: '"Lato", sans-serif',
      primaryFontWeight: 400,
    },
    hero: {
      background: hairexpressHero.src,
      textColor: "#000000",
      heroFooterBackground: "#575454",
      heroFooterTextColor: "",
    },
    backgrounds: {
      header: "var(--header-hairexpress)",
      footer: "var(--footer-hairexpress)",
      accent: "var(--accent-hairexpress)",
    },
    contactForm: {
      background: "#575454",
      link: "https://hairexpress-friseur.de/kontakt ",
    },
    newsletter: {
      background: "#575454",
      path: hairexpressNewsletter.src,
      link: "https://klierhairgroup.de/newsletter-formular",
    },
    faq: {
      background: "",
      path: "",
      link: "https://hairexpress-freiseur.de/faq",
    },
    terms: {
      loyaltyLink: "https://www.hairexpress-friseur.de/agb",
      termsLink: "https://www.hairexpress-friseur.de/agb",
      privacyLink: "https://www.hairexpress-friseur.de/datenschutz"
    },
  },

  cosmo: {
    name: "cosmo",
    brandId: 6,
    title: "COSMO BonusCard",
    brandString: "COSMO",
    colors: {
      primary: {
        hex: "#004f9e",
        rgb: "0, 79, 159",
        cmyk: "100, 70, 0, 0",
        pantone: "2768C",
        ral: "5002",
      },
      secondary: {
        hex: "#d6007e",
        rgb: "215, 0, 127",
        cmyk: "10, 100, 0, 0",
        pantone: "2405C",
        ral: "4006",
      },
      accent: {
        hex: "#e0b23a",
        rgb: "224, 178, 58",
        cmyk: "15, 30, 85, 0",
        pantone: "2645C",
        ral: "4011",
      },
    },
    logo: {
      main: {
        path: cosmoLogo.src,
        size: {
          width: "160px",
          height: "auto",
        },
        position: {
          x: "left",
          y: "center",
          padding: "0px",
        },
      },
      favicon: klierFavicon.src,
      footer: {
        path: cosmoLogo.src,
        size: {
          width: "200px",
          height: "auto",
        },
        position: {
          x: "left",
          y: "center",
          padding: "0px",
        },
      },
    },
    disturber: {
      title: "COSMO BonusCard",
      imagePath: cosmoDisturber.src,
      altText: "Premium Styling bei COSMO",
      ctaText: "Jetzt stylen lassen",
      ctaLink: "/angebote/premium-styling",
    },
    typography: {
      fontFamily: '"Roboto", sans-serif',
      headingsFontFamily: '"Roboto Condensed", sans-serif',
      primaryFontWeight: 400,
    },
    hero: {
      background: cosmoHero.src,
      textColor: "#000000",
      heroFooterBackground: "#E0B23A",
      heroFooterTextColor: "",
    },
    backgrounds: {
      header: "var(--header-cosmo)",
      footer: "var(--footer-cosmo)",
      accent: "var(--accent-cosmo)",
    },
    contactForm: {
      background: "#E0B23A",
      link: "https://cosmohairshop.de/kontakt",
    },
    newsletter: {
      background: "var(--header-cosmo)",
      path: cosmoNewsletter.src,
      link: "https://klierhairgroup.de/newsletter-formular",
    },
    faq: {
      background: "",
      path: "",
      link: "https://cosmohairshop.de/faq",
    },
    terms: {
      loyaltyLink: "https://cosmohairshop.de/agb",
      termsLink: "https://cosmohairshop.de/agb",
      privacyLink: "https://cosmohairshop.de/datenschutz"
    },
  },
};
